import React from 'react';
import type { DemoRoleMode } from '../../services/demoRoleService';

type Props = {
  mode: DemoRoleMode;
  onChange: (mode: DemoRoleMode) => void;
  compact?: boolean;
};

export function DemoRoleSwitch({ mode, onChange, compact = false }: Props) {
  return (
    <div
      className={`ws-demo-role${compact ? ' ws-demo-role--compact' : ''}`}
      role="group"
      aria-label="Режим показа datacircle"
    >
      {!compact && (
        <span className="ws-demo-role__label">Режим показа</span>
      )}
      <div className="ws-demo-role__toggle">
        <button
          type="button"
          className={`ws-demo-role__btn ${mode === 'admin' ? 'ws-demo-role__btn--active' : ''}`}
          onClick={() => onChange('admin')}
          aria-pressed={mode === 'admin'}
        >
          Администратор
        </button>
        <button
          type="button"
          className={`ws-demo-role__btn ${mode === 'user' ? 'ws-demo-role__btn--active' : ''}`}
          onClick={() => onChange('user')}
          aria-pressed={mode === 'user'}
        >
          Пользователь
        </button>
      </div>
    </div>
  );
}
